<template>
  <div>
    <h3 class="section-title">Explore OHI</h3>
    <div class="announcement-item">
      <img src="/img/ohi-portal-graphic.png" alt="ExploreOHI" />
      <div class="announcement">
        <h4 class="title">The 2024 Outdoor Hospitality Industry Outlook Report is Live!</h4>
        <p>
          The 2024 Outdoor Hospitality Industry Outlook Report is the latest iteration in a long-line of reports of its
          kind going back decades.These reports are created for your benefit and in an effort to maintain a current and
          ongoing understanding of the industry landscape. Get access to the latest data and the live recording of the
          deep-dive webinar through the link below </p>
          <a :href='"https://www.pathlms.com/arvc/courses/28187"'
          class="button-rg-green">
          Learn More
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      WP_URL: process.env.VUE_APP_WP_WEBSITE_URL,
    };
  },
};
</script>
<style lang="scss" scoped>
.section-title {
  margin: 0;
  margin-top: 50px;
  text-transform: unset;
  font-weight: normal;
  padding: 32px 0;
  color: #403f3c;
  border-top: 4px solid rgba(217, 217, 217, 0.5);
}
.announcement-item {
  display: grid;
  grid-template-columns: 65% 1fr;
  grid-column-gap: 50px;
  img {
    width: 100%;
  }
  .announcement {
    align-self: center;
    .title {
      font-weight: bold;
      color: #3594bd;
      margin-bottom: 10px;
    }
  }
  @media (max-width: 992px) {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 20px;
  }
}
</style>
